export const light = {
  alternate: {
    main: '#f7faff',
    dark: '#edf1f7',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  mode: 'light',
  primary: {
    main: '#47B59E',    //'#377dff',
    light: '#989BA2',
    dark: '#2f6ad9',    // TODO_SP : Need to check if it is needed
    contrastText: '#fff',
  },
  secondary: {
    light: '#3963AB', //'#ffb74d',
    main: '#3963AB', //'#f9b934',
    dark: '#47B59E',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  text: {
    primary: '#000000', // Black Text
    secondary: '#707070', // Grey Text
    black: '#000000',
    grey: '#707070',
  },
  button: {
    primary: '#3963AB', // Black Text
    secondary: '#47B59E', // Grey Text
  },
  background: {
    paper: '#ffffff',
    default: '#ffffff',
    level2: '#f5f5f5',
    level1: '#ffffff',
  },
};

export const dark = {
  alternate: {
    main: '#1a2138',
    dark: '#151a30',
  },
  cardShadow: 'rgba(0, 0, 0, .11)',
  common: {
    black: '#000',
    white: '#fff',
  },
  mode: 'dark',
  primary: {
    main: '#1976d2',
    light: '#2196f3',
    dark: '#0d47a1',
    contrastText: '#fff',
  },
  secondary: {
    light: '#FFEA41',
    main: '#FFE102',
    dark: '#DBBE01',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  text: {
    primary: '#EEEEEF',
    secondary: '#AEB0B4',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#222B45',
    default: '#222B45',
    level2: '#333',
    level1: '#2D3748',
  },
};
